var getBuiltIn = require('../internals/get-built-in');

module.exports = getBuiltIn('document', 'documentElement');



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/~/core-js/internals/html.js
// module id = 777
// module chunks = 1